<section class="min-h-screen">
  <div class="container mx-auto px-4 py-6 max-w-screen-2xl">

    <!-- Title Section (moved above customer profile) -->
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 text-center">
        <i class="fas fa-shopping-cart text-blue-600 mr-2"></i>
        Compras Financiadas
      </h1>
    </div>

    <!-- Customer Profile Section -->
    <div *ngIf="!loading_person && person?.person" class="mb-6">
      <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
        <div (click)="navigateToProfile()"
             class="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity">
          <div class="flex-shrink-0">
            <img
              *ngIf="person?.person?.file_selfie"
              class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
              [src]="sanitize(person?.person?.file_selfie?.url)"
              alt="Avatar del cliente"
            />
            <img
              *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
              class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
              [src]="sanitize('../assets/public/images/avatar.png')"
              alt="Avatar del cliente"
            />
            <img
              *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
              class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
              [src]="sanitize('../assets/public/images/avatara-female.png')"
              alt="Avatar del cliente"
            />
          </div>
          <div class="flex-1">
            <h2 class="text-xl font-bold text-gray-900 capitalize hover:text-blue-600 transition-colors">
              {{person?.person?.name}} {{person?.person?.lastName}}
            </h2>
            <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
              <div class="flex items-center gap-1">
                <i class="fas fa-id-card text-blue-600"></i>
                <span>{{getIdentity(person)}}</span>
              </div>
              <div class="flex items-center gap-1">
                <i class="fas fa-phone text-blue-600"></i>
                <span>{{getContact(person)}}</span>
              </div>
              <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                <i class="fas fa-envelope text-blue-600"></i>
                <span>{{getEmailContact(person)}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Header Section -->
    <div class="mb-8">
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center space-x-4">
          <button *ngIf="view != 1" (click)="closeInstallment()"
                  class="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors">
            <i class="fas fa-arrow-left"></i>
          </button>

          <!-- 💎 FILTRO MÚLTIPLE DE PRODUCTOS CON BÚSQUEDA DIRECTA -->
          <div data-rbac-permiso="compras_financiadas.filtrar_producto.read" class="position-relative product-search-input" style="width: 400px; max-width: 100%;" *ngIf="view == 1 && !loading_person && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.filtrar_producto.read']))">
              <!-- Barra de Búsqueda Principal (estilo form-floating como en post) -->
              <div class="form-floating">
                  <input
                      type="text"
                      class="form-control"
                      id="productSearchFinancial"
                      [(ngModel)]="productSearchTerm"
                      (input)="filterProductsSearch()"
                      (focus)="openDropdown()"
                      (click)="openDropdown()"
                      [readonly]="!showDropdown"
                      placeholder="Buscar tipo de producto..."
                      autocomplete="off">
                  <label for="productSearchFinancial">
                      <i class="fas fa-search me-2"></i>
                      Buscar tipo de producto
                  </label>
                  <!-- Botón limpiar -->
                  <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                      *ngIf="productSearchTerm && (selectedProducts.length > 1 || (selectedProducts.length === 1 && selectedProducts[0] !== 'CREDIT'))"
                      (click)="clearProductSearch()"
                      style="z-index: 10;">
                      <i class="fas fa-times"></i>
                  </button>
              </div>

              <!-- Dropdown Elegante -->
              <div
                  *ngIf="showDropdown"
                  class="dropdown-menu show position-absolute w-100 mt-2 shadow-lg border-0 filter-dropdown"
                  style="z-index: 1050;"
              >
                  <!-- Header con contador -->
                  <div class="px-3 py-2 bg-light border-bottom">
                      <div class="d-flex align-items-center justify-content-between">
                          <small class="text-muted fw-medium">
                              <i class="fas fa-list me-1 text-primary"></i>
                              {{ filteredProductArray.length }} producto{{ filteredProductArray.length > 1 ? 's' : '' }} encontrado{{ filteredProductArray.length > 1 ? 's' : '' }}
                          </small>
                          <span class="badge bg-primary">{{ tempSelectedProducts.length }} seleccionado{{ tempSelectedProducts.length > 1 ? 's' : '' }}</span>
                      </div>
                  </div>

                  <!-- Lista de Opciones -->
                  <div class="filter-options" style="max-height: 300px; overflow-y: auto;">

                      <!-- Loading Skeleton -->
                      <div *ngIf="filterStates.isLoadingProducts" class="p-3">
                          <div *ngFor="let item of [1,2,3]" class="d-flex align-items-center mb-3">
                              <div class="placeholder-glow flex-grow-1">
                                  <span class="placeholder col-8"></span>
                              </div>
                          </div>
                      </div>

                      <!-- Opciones Reales -->
                      <div *ngIf="!filterStates.isLoadingProducts">
                          <div
                              *ngFor="let item of filteredProductArray; trackBy: trackByProductCode"
                              class="filter-option-item px-3 py-3 border-bottom cursor-pointer"
                              [class.selected]="isProductSelected(item?.params?.code)"
                              (click)="onProductSelectionChange(item?.params?.code, !isProductSelected(item?.params?.code)); $event.stopPropagation()"
                          >
                              <div class="d-flex align-items-center">
                                  <!-- Icono -->
                                  <div class="me-3">
                                      <i class="fas fa-cube text-primary"></i>
                                  </div>

                                  <!-- Texto -->
                                  <div class="flex-grow-1">
                                      <div class="fw-medium text-dark">{{ item?.params?.name || item?.params?.code }}</div>
                                      <small class="text-muted d-block">Código: {{ item?.params?.code }}</small>
                                      <small class="text-muted d-block" *ngIf="item?.params?.dinamic_code && item?.params?.dinamic_code.length > 0">
                                          Etiqueta: {{ item?.params?.dinamic_code[0] }}
                                      </small>
                                  </div>

                                  <!-- Check de seleccionado -->
                                  <div *ngIf="isProductSelected(item?.params?.code)">
                                      <i class="fas fa-check text-primary fa-lg"></i>
                                  </div>
                              </div>
                          </div>

                          <!-- Mensaje cuando no hay resultados -->
                          <div *ngIf="filteredProductArray.length === 0" class="text-center py-4">
                              <i class="fas fa-search fa-3x text-muted mb-3"></i>
                              <h6 class="text-muted">No se encontraron productos</h6>
                              <p class="text-muted small">Intenta con otro término de búsqueda</p>
                          </div>
                      </div>
                  </div>

                  <!-- Footer con Controles -->
                  <div class="px-3 py-3 bg-light border-top">
                      <!-- Info -->
                      <div class="d-flex align-items-center justify-content-between mb-3">
                          <small class="text-muted">
                              <i class="fas fa-info-circle text-primary me-1"></i>
                              {{ tempSelectedProducts.length }} de {{ productArray.length }} seleccionados
                          </small>

                          <!-- Botón Limpiar -->
                          <button
                              *ngIf="tempSelectedProducts.length > 1 || (tempSelectedProducts.length === 1 && tempSelectedProducts[0] !== 'CREDIT')"
                              type="button"
                              class="btn btn-sm btn-outline-secondary"
                              (click)="clearAllProductFilters()"
                          >
                              <i class="fas fa-times me-1"></i>
                              Limpiar
                          </button>
                      </div>

                      <!-- Botones de Acción -->
                      <div class="d-flex gap-2">
                          <!-- Cancelar -->
                          <button
                              type="button"
                              class="btn btn-outline-secondary flex-fill"
                              (click)="closeDropdown()"
                              [disabled]="filterStates.isApplyingFilter"
                          >
                              Cancelar
                          </button>

                          <!-- Aplicar -->
                          <button
                              type="button"
                              class="btn btn-primary flex-fill"
                              (click)="applyFilters()"
                              [disabled]="filterStates.isApplyingFilter"
                          >
                              <span *ngIf="!filterStates.isApplyingFilter">
                                  <i class="fas fa-check me-1"></i>
                                  Aplicar
                              </span>
                              <span *ngIf="filterStates.isApplyingFilter">
                                  <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                                  Aplicando...
                              </span>
                          </button>
                      </div>
                  </div>
              </div>

              <!-- Estado de Error -->
              <div *ngIf="filterStates.hasError" class="alert alert-danger mt-3" role="alert">
                  <div class="d-flex align-items-start">
                      <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
                      <div class="flex-grow-1">
                          <strong>Error en el filtro</strong>
                          <div class="small">{{ filterStates.errorMessage }}</div>
                          <button
                              type="button"
                              class="btn btn-sm btn-outline-danger mt-2"
                              (click)="retryOperation()"
                          >
                              <i class="fas fa-redo me-1"></i>
                              Reintentar
                          </button>
                      </div>
                  </div>
              </div>
          </div>

          <!-- Filtro LOCAL de comercio (multicomercio). No es el selector de arriba:
               arranca siempre en «Todos» para no esconder deuda del cliente. Se
               arma con los comercios de las compras ya cargadas. -->
          <div class="form-floating" style="min-width: 220px;" *ngIf="view == 1 && !loading_person && comerciosDelCliente.length">
            <select class="form-select" id="filtroComercioCliente" [(ngModel)]="filtroComercio">
              <option value="">Todos</option>
              <option *ngFor="let c of comerciosDelCliente" [value]="c.code">{{ c.name }} ({{ c.code }})</option>
            </select>
            <label for="filtroComercioCliente">Comercio</label>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row gap-3" *ngIf="!loading_person && person?.person && view == 1">
          <button (click)="refreshData()"
                  class="px-4 py-2 bg-blue-50 text-blue-600 border border-blue-300 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium">
            <i class="fas fa-sync-alt mr-2"></i>
            Actualizar
          </button>
          <button *ngIf="!env?.production"
                  (click)="restClient()"
                  class="px-4 py-2 bg-gray-50 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium">
            <i class="fas fa-trash-alt mr-2"></i>
            Eliminar compras financiadas
          </button>
          <button *ngIf="!env?.production" type="button"
                  class="px-4 py-2 bg-gray-50 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium"
                  [routerLink]="['/console/credit-save']"
                  (click)="setIdentity()">
            <i class="fas fa-plus mr-2"></i>
            Nueva compra financiada
          </button>
        </div>
      </div>

      <!-- Statistics Cards -->
      <div data-rbac-permiso="compras_financiadas.compras.read" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6" *ngIf="!loading_person && person?.person && view == 1 && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.compras.read']))">
        <!-- Pendientes -->
        <div (click)="togglePendingFilter()"
             class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-yellow-400 cursor-pointer transition-all duration-200 hover:shadow-md transform hover:scale-105"
             [ngClass]="{
               'ring-2 ring-yellow-500 shadow-lg': isPendingFilterActive(),
               'opacity-60': hasActiveFilters() && !isPendingFilterActive()
             }">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">Pendientes</p>
              <p class="text-2xl font-bold text-gray-900">{{getPendingCount()}}</p>
            </div>
            <div class="p-3 bg-yellow-50 rounded-full">
              <i class="fas fa-clock text-yellow-600 text-xl"></i>
            </div>
          </div>
        </div>

        <!-- Completados -->
        <div (click)="toggleCompletedFilter()"
             class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-green-400 cursor-pointer transition-all duration-200 hover:shadow-md transform hover:scale-105"
             [ngClass]="{
               'ring-2 ring-green-500 shadow-lg': isCompletedFilterActive(),
               'opacity-60': hasActiveFilters() && !isCompletedFilterActive()
             }">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">Completados</p>
              <p class="text-2xl font-bold text-gray-900">{{getCompletedCount()}}</p>
            </div>
            <div class="p-3 bg-green-50 rounded-full">
              <i class="fas fa-check-circle text-green-600 text-xl"></i>
            </div>
          </div>
        </div>

        <!-- En borrador -->
        <div (click)="toggleTrashFilter()"
             class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-gray-400 cursor-pointer transition-all duration-200 hover:shadow-md transform hover:scale-105"
             [ngClass]="{
               'ring-2 ring-gray-500 shadow-lg': isTrashFilterActive(),
               'opacity-60': hasActiveFilters() && !isTrashFilterActive()
             }">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">En borrador</p>
              <p class="text-2xl font-bold text-gray-900">{{getTrashCount()}}</p>
            </div>
            <div class="p-3 bg-gray-50 rounded-full">
              <i class="fas fa-ban text-gray-600 text-xl"></i>
            </div>
          </div>
        </div>

        <!-- Total -->
        <div (click)="toggleTotalFilter()"
             class="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-400 cursor-pointer transition-all duration-200 hover:shadow-md transform hover:scale-105"
             [ngClass]="{
               'ring-2 ring-blue-500 shadow-lg': isTotalFilterActive(),
               'opacity-60': hasActiveFilters() && !isTotalFilterActive()
             }">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">Total</p>
              <p class="text-2xl font-bold text-gray-900">{{getTotalCount()}}</p>
            </div>
            <div class="p-3 bg-blue-50 rounded-full">
              <i class="fas fa-chart-bar text-blue-600 text-xl"></i>
            </div>
            </div>
          </div>
        </div>

        <!-- Filter Results Info -->
      <div *ngIf="hasActiveFilters() && view == 1" class="mb-6">
        <div class="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div class="flex flex-wrap items-center gap-2">
              <span class="text-sm text-gray-600">Mostrando:</span>
              <span *ngIf="filterOptions.pending" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                Pendientes
              </span>
              <span *ngIf="filterOptions.completed" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Completados
              </span>
              <span *ngIf="filterOptions.trash" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                En borrador
              </span>
            </div>
            <div class="flex items-center gap-3">
            <span class="text-sm font-medium text-gray-700">
              {{getDisplayedInvoices()?.length || 0}} de {{getTotalCount()}} compras
            </span>
              <button
                (click)="clearAllFilters()"
                class="px-3 py-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors text-sm">
                <i class="fas fa-times mr-1"></i>
                Limpiar filtros
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="space-y-6">
      <!-- Loading de Resultados -->
      <div *ngIf="filterStates.isLoadingResults" class="space-y-4">
          <div *ngFor="let item of [1,2,3]" class="bg-white rounded-lg shadow-sm">
              <div class="placeholder-glow">

                  <!-- Transaction Header -->
                  <div class="p-4 border-b border-gray-200">
                      <div class="space-y-1">
                          <span class="placeholder col-3 rounded" style="height: 14px;"></span>
                          <span class="placeholder col-6 rounded" style="height: 18px;"></span>
                      </div>
                  </div>

                  <!-- Payment Details -->
                  <div class="p-6">
                      <!-- Grid de información principal (3 columnas en lg, 2 en md, 1 en sm) -->
                      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">

                          <!-- Primera fila -->
                          <div class="space-y-1">
                              <span class="placeholder col-8 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-10 rounded" style="height: 20px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-7 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-9 rounded" style="height: 16px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-6 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-8 rounded" style="height: 16px;"></span>
                          </div>

                          <!-- Segunda fila -->
                          <div class="space-y-1">
                              <span class="placeholder col-5 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-7 rounded" style="height: 16px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-4 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-6 rounded" style="height: 16px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-6 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-8 rounded" style="height: 16px;"></span>
                          </div>

                          <!-- Tercera fila -->
                          <div class="space-y-1">
                              <span class="placeholder col-4 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-7 rounded" style="height: 16px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-5 rounded" style="height: 14px;"></span>
                              <span class="placeholder rounded-pill" style="width: 80px; height: 20px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-5 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-6 rounded" style="height: 16px;"></span>
                              <span class="placeholder col-4 rounded" style="height: 14px; margin-top: 4px;"></span>
                          </div>

                          <!-- Cuarta fila -->
                          <div class="space-y-1">
                              <span class="placeholder col-6 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-8 rounded" style="height: 16px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-7 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-9 rounded" style="height: 16px;"></span>
                          </div>

                          <div class="space-y-1">
                              <span class="placeholder col-7 rounded" style="height: 14px;"></span>
                              <span class="placeholder col-9 rounded" style="height: 16px;"></span>
                          </div>
                      </div>

                      <!-- Action Buttons -->
                      <div class="flex flex-wrap gap-3 mt-6 pt-6 border-t border-gray-200">
                          <span class="placeholder rounded-lg" style="width: 180px; height: 36px;"></span>
                          <span class="placeholder rounded-lg" style="width: 150px; height: 36px;"></span>
                          <span class="placeholder rounded-lg" style="width: 120px; height: 36px;"></span>
                      </div>

                      <!-- Promissory Note Status -->
                      <div class="mt-6 p-4 bg-gray-50 rounded-lg">
                          <span class="placeholder col-4 rounded mb-3 d-block" style="height: 16px;"></span>
                          <div class="space-y-2">
                              <div class="d-flex">
                                  <span class="placeholder col-6 rounded" style="height: 14px;"></span>
                                  <span class="placeholder rounded-pill ms-2" style="width: 80px; height: 14px;"></span>
                              </div>
                              <div class="d-flex">
                                  <span class="placeholder col-5 rounded" style="height: 14px;"></span>
                                  <span class="placeholder col-4 rounded ms-2" style="height: 14px;"></span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!-- Overlay de Carga -->
      <div *ngIf="filterStates.isApplyingFilter && !filterStates.isLoadingResults"
           class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
           style="z-index: 1055; background: rgba(255,255,255,0.9);">
          <div class="text-center">
              <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Cargando...</span>
              </div>
              <h5 class="text-primary">Aplicando filtros</h5>
              <p class="text-muted mb-0">Obteniendo compras financiadas...</p>
          </div>
      </div>

      <!-- Financial Purchases List -->
      <div data-rbac-permiso="compras_financiadas.compras.read" *ngIf="!loading && person?.person && view == 1 && !filterStates.isLoadingResults && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.compras.read']))">
        <div class="space-y-4">
          <div *ngFor="let item of getDisplayedInvoices()" class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">

            <!-- Transaction Header -->
            <div class="p-4 border-b border-gray-200 flex flex-wrap items-start justify-between gap-3">
              <div>
                <p class="text-sm font-medium text-gray-500">ID transacción</p>
                <p class="flex items-center gap-1 text-lg font-semibold text-blue-600 font-mono">{{item?.identifier}}<app-copiar [texto]="item?.identifier" etiqueta="el ID de transacción"></app-copiar></p>
                <!-- 🆕 Badge de crédito clasificado como pérdida incobrable -->
                <span *ngIf="item?.cartera?.estado === 'INCOBRABLE'"
                      class="inline-flex items-center mt-1 px-2 py-0.5 rounded-md text-xs font-semibold bg-red-50 text-red-700 border border-red-200">
                  Pérdida Incobrable
                </span>
              </div>
            </div>

            <!-- Payment Details -->
            <div class="p-6">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <!-- Total Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Compra financiada total</p>
                  <p class="text-xl font-bold text-gray-900">
                    {{item?.totalAmount | currency:'USD':'': '1.2-2'}}
                    <span class="text-sm font-normal text-gray-500">USD</span>
                  </p>
                </div>

                <!-- Approval Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha de compra</p>
                  <p class="text-sm text-gray-900">{{item?.dueDate | date: 'dd/MM/yyyy h:mm:ss a'}}</p>
                </div>

                <!-- Document ID -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">ID documento</p>
                  <p class="flex items-center gap-1 text-sm text-gray-900 font-mono">{{item?.merchantNumber}}<app-copiar [texto]="item?.merchantNumber" etiqueta="el ID de documento"></app-copiar></p>
                </div>

                <!-- Comercio (Mario, 12-oct: sin comercio = Mundo Total) -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Comercio</p>
                  <p class="text-sm text-gray-900">{{ comercioDe(item) }}</p>
                </div>

                <!-- Liquidación al comercio (EST-01; solo con liquidacion.consultar) -->
                <div class="space-y-1" *ngIf="puedeLiq && marcasCompras[item?.code] as m">
                  <p class="text-sm font-medium text-gray-500">Liquidación al comercio</p>
                  <button type="button" class="text-left" (click)="abrirTrazaLiq(item?.code)" title="Ver la traza">
                    <span [ngClass]="claseMarca(m.estado)">{{ m.texto }}</span>
                    <span class="flex flex-wrap items-center gap-x-1 text-xs text-gray-500" *ngIf="m.liquidacion"><button type="button" class="font-mono underline decoration-dotted underline-offset-2 hover:decoration-solid" (click)="fichaLiq.abrir(m.liquidacion); $event.stopPropagation()" title="Ver la liquidación">{{ m.liquidacion }}</button><app-copiar [texto]="m.liquidacion" etiqueta="la liquidación"></app-copiar><span *ngIf="m.pagado_el"> · pagado {{ fechaLiq(m.pagado_el) }}</span><span *ngIf="!m.pagado_el && m.dia_cierre"> · cierre {{ fechaLiq(m.dia_cierre) }}</span></span>
                  </button>
                </div>

                <!-- Store -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Tienda</p>
                  <p class="text-sm text-gray-900">{{ nombreTienda(item?.provider_transaction?.shop) }}<span *ngIf="tieneNombreTienda(item?.provider_transaction?.shop)" class="ml-1 text-xs text-gray-400">({{ item?.provider_transaction?.shop }})</span></p>
                </div>

                <!-- Cash Register -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Caja</p>
                  <p class="text-sm text-gray-900">{{item?.provider_transaction?.cash_register}}</p>
                </div>

                <!-- Cashier ID -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">C.I. Cajero</p>
                  <p class="text-sm text-gray-900">{{item?.provider_transaction?.user}}</p>
                </div>

                <!-- Plan -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Plan</p>
                  <p class="text-sm text-gray-900">{{item?.plan?.name}}</p>
                </div>

                <!-- Status -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Estatus</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="{
                          'bg-green-100 text-green-800': item?.payment_status?.code == 'PaymentComplete',
                          'bg-yellow-100 text-yellow-800': item?.payment_status?.code == 'PaymentPending',
                          'bg-gray-100 text-gray-800': item?.payment_status?.code == 'PaymentTrash'
                        }">
                    {{getStatusDisplayName(item?.payment_status?.name)}}
                  </span>
                </div>

                <!-- Installments -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Cuotas</p>
                  <p class="text-sm text-gray-900">{{item?.plan?.number_installment || item?.plan?.min_number_installment}}</p>
                  <button (click)="getPersonInstallmentsInvoiceCredits(item)" class="text-sm text-blue-600 hover:text-blue-800 font-medium mt-1 block">
                    Ver cuotas
                  </button>
                </div>

                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto inicial</p>
                  <p class="text-sm text-gray-900">
                    {{item?.minimumPaymentDue | currency:'USD':'': '1.2-2'}}
                    <span class="text-xs text-gray-500">USD</span>
                  </p>
                </div>

                <!-- Financed Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto financiado</p>
                  <p class="text-sm text-gray-900">
                    {{item?.amount | currency:'USD':'': '1.2-2'}}
                    <span class="text-xs text-gray-500">USD</span>
                  </p>
                </div>

                <!-- Pending Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto pendiente</p>
                  <p class="text-sm text-gray-900">
                    {{item?.dueBalance | currency:'USD':'': '1.2-2'}}
                    <span class="text-xs text-gray-500">USD</span>
                  </p>
                </div>
              </div>

              <!-- Cobrado con la inicial: cargo por uso de la plataforma y extras del comercio
                   (P-245/P-267, 23-sep). No es parte del crédito -no está en "Monto financiado"
                   ni en "Monto inicial"-: ya viene en el invoice (`usage_fee`, `extras`) y sólo
                   faltaba mostrarlo, para que no parezca que ese dólar no se cobró. -->
              <div class="mt-4 pt-4 border-t border-gray-100" *ngIf="item?.usage_fee || item?.extras?.length > 0">
                <p class="text-sm font-semibold text-gray-700 mb-2">
                  <i class="fas fa-receipt mr-1 text-blue-600"></i>
                  Cobrado con la inicial
                </p>
                <div class="space-y-2">
                  <div *ngIf="item?.usage_fee" class="flex items-center justify-between text-sm bg-gray-50 rounded px-3 py-2">
                    <span class="text-gray-800">{{item.usage_fee.concept || 'Uso de la plataforma'}}</span>
                    <span class="text-gray-700 font-mono flex items-center">
                      {{item.usage_fee.amount_usd | currency:'USD':'': '1.2-2'}} USD
                      <span class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Cobrado</span>
                    </span>
                  </div>
                  <div *ngFor="let extra of item?.extras" class="flex items-center justify-between text-sm bg-gray-50 rounded px-3 py-2">
                    <span class="text-gray-800">{{extra.concept}}</span>
                    <span class="text-gray-700 font-mono flex items-center">
                      {{extra.amount_usd | currency:'USD':'': '1.2-2'}} USD
                      <span class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Cobrado</span>
                    </span>
                  </div>
                </div>
                <p class="text-xs text-gray-500 mt-2">
                  No se financia: es del comercio y de CrediTotal, no del crédito del cliente.
                </p>
              </div>

              <!-- Productos de la compra -->
              <div data-rbac-permiso="compras_financiadas.productos.read" class="mt-4 pt-4 border-t border-gray-100"
                   *ngIf="(item?.order_items?.items?.length > 0)
                          && (!_auth.hasRbac$.getValue() || _auth.hasPermission('compras_financiadas.productos.read'))">
                <p class="text-sm font-semibold text-gray-700 mb-2">
                  <i class="fas fa-box mr-1 text-blue-600"></i>
                  Productos ({{item.order_items.items.length}})
                </p>
                <div class="space-y-2">
                  <div *ngFor="let product of item.order_items.items"
                       class="flex items-center justify-between text-sm bg-gray-50 rounded px-3 py-2">
                    <div class="flex-1">
                      <span class="font-medium text-gray-800">{{product.name}}</span>
                      <span class="text-gray-500 ml-2">x{{product.quantity}}</span>
                    </div>
                    <span class="text-gray-700 font-mono">
                      {{product.unit_price | currency:'USD':'': '1.2-2'}} USD
                    </span>
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="flex flex-wrap gap-3 mt-6 pt-6 border-t border-gray-200">
                <!-- Botón Ver Póliza (solo para seguros) -->
                <button data-rbac-permiso="compras_financiadas.polizas.download" *ngIf="isInsuranceProduct(item) && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.polizas.download']))"
                        (click)="viewPolicy(item)"
                        class="px-4 py-2 bg-purple-50 text-purple-600 border border-purple-200 rounded-lg hover:bg-purple-100 transition-colors text-sm font-medium">
                  <i class="fas fa-file-contract mr-2"></i>
                  Ver Póliza
                </button>

                <button *ngIf="isNeteable[item.code] == true && item?.dueBalance > 0"
                        (click)="register_netable_payment(item.code)"
                        class="px-4 py-2 bg-red-50 text-red-600 border border-red-200 rounded-lg hover:bg-red-100 transition-colors text-sm font-medium">
                  <i class="fas fa-dollar-sign mr-2"></i>
                  Saldar monto {{item?.dueBalance | currency:'USD':'': '1.2-2'}} USD
                </button>

                <button data-rbac-permiso="compras_financiadas.pagares.download" *ngIf="item?.params?.pagare?.url && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.pagares.download']))"
                        (click)="downloadPdf(item?.params?.pagare?.url)"
                        class="px-4 py-2 bg-blue-50 text-blue-600 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium">
                  <i class="fas fa-download mr-2"></i>
                  Descargar pagaré
                </button>

                <button data-rbac-permiso="compras_financiadas.anular_compra.cancel" *ngIf="(_auth.hasRbac$.getValue() ? _auth.hasAnyPermission(['compras_financiadas.anular_compra.cancel']) : _auth.hasAccessOrProfile('contactos', ['OWNER'])) && item?.payment_status?.code !== 'PaymentTrash'"
                        (click)="anularCompra(item)"
                        class="px-4 py-2 bg-red-50 text-red-600 border border-red-200 rounded-lg hover:bg-red-100 transition-colors text-sm font-medium">
                  <i class="fas fa-ban mr-2"></i>
                  Anular Compra
                </button>
              </div>

              <!-- Auditoría de anulación: SOLO se muestra si llegó el objeto annulment.
                   Las compras anuladas antes de esta funcionalidad no lo tienen y no
                   muestran nada (retrocompatible). -->
              <div *ngIf="item?.annulment"
                   class="mt-3 px-3 py-2 rounded-md border border-red-200 bg-red-50 text-xs text-gray-700">
                <span class="font-semibold text-red-700"><i class="fas fa-ban mr-1"></i>Compra anulada</span>
                <span class="text-gray-400 mx-1">·</span>
                <span>{{ item?.annulment?.by_user?.name }} {{ item?.annulment?.by_user?.lastName }}</span>
                <span class="text-gray-400 mx-1">·</span>
                <span *ngIf="item?.annulment?.at">{{ item?.annulment?.at | date: 'dd/MM/yyyy HH:mm' }}</span>
                <span class="d-block mt-1"><span class="font-medium">Motivo:</span> {{ item?.annulment?.reason || 'Sin motivo registrado' }}</span>
              </div>

              <!-- Promissory Note Status -->
              <div data-rbac-permiso="compras_financiadas.pagares.download" class="mt-6 p-4 bg-gray-50 rounded-lg" *ngIf="!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.pagares.download'])">
                <h4 class="text-sm font-semibold text-gray-900 mb-3">Estado del Pagaré</h4>
                <div class="space-y-2 text-sm">
                  <div>
                    <span class="text-gray-600">Aprobación de pagaré: </span>
                    <span class="font-medium"
                          [ngClass]="{
                            'text-green-600': item?.params?.pagare?.accepted === true,
                            'text-red-600': item?.params?.pagare?.accepted === false,
                            'text-yellow-600': item?.params?.pagare?.accepted !== false && item?.params?.pagare?.accepted !== true
                          }">
                      {{item?.params?.pagare?.accepted === true ? 'Aceptado' :
                        item?.params?.pagare?.accepted === false ? 'No aceptado' : 'Por aceptar'}}
                    </span>
                  </div>
                  <div *ngIf="item?.params?.pagare?.declined_reason">
                    <span class="text-gray-600">Razón de rechazo: </span>
                    <span class="font-medium text-gray-900">{{item?.params?.pagare?.declined_reason}}</span>
                  </div>
                  <div *ngIf="item?.params?.pagare?.date_accepted">
                    <span class="text-gray-600">Fecha de aprobación: </span>
                    <span class="font-medium text-gray-900">{{item?.params?.pagare?.date_accepted | date: 'dd/MM/yyyy'}}</span>
                  </div>
                </div>
              </div>

              <!-- Policy Details (solo para seguros) -->
              <div data-rbac-permiso="compras_financiadas.polizas.download" *ngIf="selectedPolicy && selectedPolicyInvoice === item.code && (!_auth.hasRbac$.getValue() || _auth.hasAnyPermission(['compras_financiadas.polizas.download']))" class="mt-6 p-4 bg-purple-50 rounded-lg border border-purple-200">
                <div class="flex items-center justify-between mb-3">
                  <h4 class="text-sm font-semibold text-purple-900 flex items-center">
                    <i class="fas fa-file-contract mr-2"></i>
                    Detalles de la Póliza
                  </h4>
                  <button (click)="closePolicy()" class="text-purple-600 hover:text-purple-800">
                    <i class="fas fa-times"></i>
                  </button>
                </div>

                <!-- Loading State -->
                <div *ngIf="loadingPolicy" class="text-center py-4">
                  <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto"></div>
                  <p class="text-sm text-purple-600 mt-2">Cargando póliza...</p>
                </div>

                <!-- Policy Data -->
                <div *ngIf="!loadingPolicy && selectedPolicy" class="space-y-3 text-sm">
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3">
                    
                    <!-- Código de la Póliza -->
                    <div>
                      <span class="text-purple-700 font-medium">Código de la Póliza:</span>
                      <p class="font-mono text-sm text-purple-900 break-all">{{selectedPolicy?.code || 'N/A'}}</p>
                    </div>

                    <!-- Producto de Seguro -->
                    <div>
                      <span class="text-purple-700 font-medium">Producto:</span>
                      <p class="text-purple-900">
                        <span *ngIf="selectedPolicy?.product_name">{{selectedPolicy?.product_name}}</span>
                        <span *ngIf="selectedPolicy?.product_code" class="text-xs text-purple-600 ml-2">({{selectedPolicy?.product_code}})</span>
                        <span *ngIf="!selectedPolicy?.product_name && !selectedPolicy?.product_code">{{selectedPolicy?.insurance_product}}</span>
                      </p>
                    </div>

                    <!-- Número de Póliza -->
                    <div>
                      <span class="text-purple-700 font-medium">Número de Póliza:</span>
                      <p class="text-purple-900 font-semibold">{{selectedPolicy?.policy_number || 'N/A'}}</p>
                    </div>

                    <!-- Número de Recibo -->
                    <div>
                      <span class="text-purple-700 font-medium">Número de Recibo:</span>
                      <p class="text-purple-900 font-semibold">{{selectedPolicy?.receipt_number || 'N/A'}}</p>
                    </div>

                    <!-- Tasa de Cambio -->
                    <div class="md:col-span-2">
                      <span class="text-purple-700 font-medium">Tasa de Cambio:</span>
                      <p class="text-purple-900 font-semibold">1 USD = {{selectedPolicy?.exchange_rate | number:'1.2-2'}} BS</p>
                    </div>

                  </div>
                </div>

                <!-- Error State -->
                <div *ngIf="policyError" class="text-center py-4">
                  <i class="fas fa-exclamation-triangle text-red-500 text-2xl mb-2"></i>
                  <p class="text-sm text-red-600">{{policyError}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Data Message -->
      <div *ngIf="!loading && !loading_person && person?.person && resp_invoiceCredits?.length < 1" class="text-center py-12">
        <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <i class="fas fa-shopping-cart text-2xl text-gray-400"></i>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">No se encontraron compras financiadas</h3>
        <p class="text-gray-500">Este cliente no tiene compras financiadas registradas</p>
      </div>

      <!-- Person Not Found -->
      <div *ngIf="!loading_person && !person?.person" class="text-center py-12">
        <div class="mx-auto w-24 h-24 bg-red-100 rounded-full flex items-center justify-center mb-4">
          <i class="fas fa-exclamation-triangle text-2xl text-red-400"></i>
        </div>
        <h3 class="text-lg font-medium text-gray-900 mb-2">Cliente no encontrado</h3>
        <p class="text-red-600">No se encontró persona con este ID: {{queryParams?.code}}</p>
      </div>

      <!-- Loading State -->
      <div *ngIf="loading_person || loading" class="flex items-center justify-center py-12">
        <div class="text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p class="text-gray-600 mt-4">Cargando...</p>
        </div>
      </div>

      <!-- Installments View -->
      <div *ngIf="view == 2" class="max-w-4xl mx-auto">

        <!-- Invoice Header -->
        <div *ngIf="installments" class="bg-white rounded-lg shadow-sm p-6 mb-6 text-center">
          <div class="border-b border-gray-200 pb-4 mb-4">
            <h2 class="text-xl font-bold text-gray-900 mb-2">Detalle de Cuotas</h2>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
            <div>
              <p class="text-sm font-medium text-gray-500">ID Transacción</p>
              <p class="inline-flex items-center gap-1 text-lg font-semibold text-blue-600">{{invoiceSelected?.identifier}}<app-copiar [texto]="invoiceSelected?.identifier" etiqueta="el ID de transacción"></app-copiar></p>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Total</p>
              <p class="text-lg font-semibold text-gray-900">
                {{invoiceSelected?.totalAmount | currency:'USD':'': '1.2-2'}}
                <span class="text-sm font-normal text-gray-500">USD</span>
              </p>
            </div>
            <div>
              <p class="text-sm font-medium text-gray-500">Monto pendiente</p>
              <p class="text-lg font-semibold text-gray-900">
                {{invoiceSelected?.dueBalance | currency:'USD':'': '1.2-2'}}
                <span class="text-sm font-normal text-gray-500">USD</span>
              </p>
            </div>
          </div>

          <p class="mt-3 inline-flex items-center justify-center gap-2 text-sm text-gray-600">Comercio: <b class="text-gray-900">{{ comercioDe(invoiceSelected) }}</b></p>

          <!-- Liquidación al comercio de esta compra (EST-01/02; solo con liquidacion.consultar) -->
          <div class="mt-4 rounded-lg border border-gray-200 p-4 text-left" *ngIf="puedeLiq && liqCompra">
            <div class="flex flex-wrap items-center justify-between gap-2">
              <p class="m-0 text-sm font-semibold text-gray-900">Liquidación al comercio</p>
              <span [ngClass]="claseMarca(liqCompra.estado)">{{ liqCompra.texto }}</span>
            </div>
            <div class="mt-3 grid grid-cols-2 gap-3 text-sm md:grid-cols-4">
              <div *ngIf="liqCompra.liquidacion"><p class="m-0 text-xs text-gray-500">Liquidación</p><b class="inline-flex items-center gap-1"><button type="button" class="font-mono font-bold underline decoration-dotted underline-offset-2 hover:decoration-solid" (click)="fichaLiq.abrir(liqCompra.liquidacion); $event.stopPropagation()" title="Ver la liquidación">{{ liqCompra.liquidacion }}</button><app-copiar [texto]="liqCompra.liquidacion" etiqueta="la liquidación"></app-copiar></b></div>
              <div *ngIf="liqCompra.dia_cierre"><p class="m-0 text-xs text-gray-500">Cierre</p><b>{{ fechaLiq(liqCompra.dia_cierre) }}</b></div>
              <div *ngIf="liqCompra.vence && !liqCompra.liquidacion"><p class="m-0 text-xs text-gray-500">Vence</p><b>{{ fechaLiq(liqCompra.vence) }}</b></div>
              <div *ngIf="liqCompra.pagado_el"><p class="m-0 text-xs text-gray-500">Pagado al comercio</p><b>{{ fechaLiq(liqCompra.pagado_el) }}</b></div>
              <div *ngIf="liqCompra.referencia" class="col-span-2"><p class="m-0 text-xs text-gray-500">Lote · referencia</p><b class="inline-flex flex-wrap items-center gap-1 font-mono text-xs">{{ liqCompra.lote }}<app-copiar [texto]="liqCompra.lote" etiqueta="el lote"></app-copiar> · {{ liqCompra.referencia }}<app-copiar [texto]="liqCompra.referencia" etiqueta="la referencia bancaria"></app-copiar></b></div>
              <div *ngIf="liqCompra.modelo === 'COBRANZA'" class="col-span-2"><p class="m-0 text-xs text-gray-500">Avance</p><b>{{ liqCompra.cuotas_liquidadas }} de {{ liqCompra.n_cuotas }} cuotas liquidadas</b></div>
            </div>
            <button type="button" class="mt-3 text-sm underline" (click)="abrirTrazaLiq(invoiceSelected?.code)">Ver traza</button>
          </div>

          <div class="mt-4 flex items-center justify-between flex-wrap gap-2">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
              Cuotas: {{installments?.length}}
            </span>
            <!-- Preguntar es por PÓLIZA porque el summary de Mercantil lo es: una
                 llamada (~4 s) refresca el estado de todas sus cuotas. Sin esto,
                 lo que se ve abajo es el último corte del sync, que dejó de mirar
                 la cuota justo cuando la cobramos. -->
            <!-- Preguntar a SM reescribe el espejo de la póliza, así que pide su
                 propio permiso y no el de lectura de la consola. -->
            <button data-rbac-permiso="seguros.cuotas.consultar_sm seguros.reporte_pagos.manage" *ngIf="esCreditoSegurosMercantil && policyCodeSM && _auth.hasAnyPermission(['seguros.cuotas.consultar_sm', 'seguros.reporte_pagos.manage'])"
                    (click)="refrescarPolizaSM()" [disabled]="refrescandoSM" type="button"
                    class="text-sm px-3 py-1.5 border rounded hover:bg-gray-50 disabled:opacity-50">
              <i class="fas mr-1" [ngClass]="refrescandoSM ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
              {{ refrescandoSM ? 'Consultando…' : 'Preguntar a SM' }}
            </button>
          </div>

          <!-- Cobrado con la inicial (P-245/P-267): mismo dato que en el listado, acá también
               porque esta cabecera es el detalle al que se llega con "Ver cuotas". -->
          <div class="mt-4 pt-4 border-t border-gray-100 text-left" *ngIf="invoiceSelected?.usage_fee || invoiceSelected?.extras?.length > 0">
            <p class="text-sm font-semibold text-gray-700 mb-2">
              <i class="fas fa-receipt mr-1 text-blue-600"></i>
              Cobrado con la inicial
            </p>
            <div class="space-y-2">
              <div *ngIf="invoiceSelected?.usage_fee" class="flex items-center justify-between text-sm bg-gray-50 rounded px-3 py-2">
                <span class="text-gray-800">{{invoiceSelected.usage_fee.concept || 'Uso de la plataforma'}}</span>
                <span class="text-gray-700 font-mono flex items-center">
                  {{invoiceSelected.usage_fee.amount_usd | currency:'USD':'': '1.2-2'}} USD
                  <span class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Cobrado</span>
                </span>
              </div>
              <div *ngFor="let extra of invoiceSelected?.extras" class="flex items-center justify-between text-sm bg-gray-50 rounded px-3 py-2">
                <span class="text-gray-800">{{extra.concept}}</span>
                <span class="text-gray-700 font-mono flex items-center">
                  {{extra.amount_usd | currency:'USD':'': '1.2-2'}} USD
                  <span class="ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Cobrado</span>
                </span>
              </div>
            </div>
            <p class="text-xs text-gray-500 mt-2">
              No se financia: es del comercio y de CrediTotal, no del crédito del cliente.
            </p>
          </div>
        </div>

        <!-- Installments List -->
        <div class="space-y-4">
          <div *ngFor="let item of installments; let i = index" class="bg-white rounded-lg shadow-sm">

            <!-- Installment Header -->
            <div class="p-4 border-b border-gray-200">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-semibold text-gray-900">
                  {{ item?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item?.installMent?.order}}
                </h3>
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="{
                        'bg-green-100 text-green-800': item?.installMent?.payment_status?.code == 'PaymentComplete' || item?.installMent?.payment_status_remante_base,
                        'bg-yellow-100 text-yellow-800': item?.installMent?.payment_status?.code != 'PaymentComplete' && !item?.installMent?.payment_status_remante_base
                      }">
                  {{item?.installMent?.payment_status_remante_base ? 'Pago Completado' : item?.installMent?.payment_status?.name}}
                </span>
              </div>
              <p class="mt-2 mb-0 text-xs text-gray-600" *ngIf="puedeLiq && marcaDeCuota(item) as mc">
                Liquidación al comercio: <span [ngClass]="claseMarca(mc.estado)">{{ mc.texto }}</span>
              </p>
            </div>

            <!-- Installment Details -->
            <div class="p-6">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

                <!-- Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Total</p>
                  <p class="text-lg font-semibold text-gray-900">
                    {{item?.installMent?.amount | currency:'USD':'': '1.2-2'}} USD
                  </p>
                  <div *ngIf="item?.installMent?.payment_status_remante_base" class="text-green-600 text-sm">
                    -{{item?.installMent?.total_remaining_base}} USD
                  </div>
                  <div *ngIf="item?.installMent?.payment_status_remante_next" class="text-red-600 text-sm">
                    +{{item?.installMent?.total_remaining_next}} USD
                  </div>
                </div>

                <!-- Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha</p>
                  <p class="text-sm text-gray-900">{{item?.installMent?.date | date: 'dd/MM/yyyy'}}</p>
                </div>

                <!-- Payment Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha de Pago</p>
                  <p class="text-sm text-gray-900">{{item?.installMent?.scheduledPaymentDate | date: 'dd/MM/yyyy'}}</p>
                </div>

                <!-- Paid Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Pagada</p>
                  <p class="text-sm text-gray-900">
                    {{ (item?.installMent?.amount - item?.installMent?.dueBalance) | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>

                <!-- Pending Reconciliation -->
                <div *ngIf="item?.totalpaymentReference > 0" class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Total (Por conciliar)</p>
                  <p class="text-sm text-gray-900">
                    {{item?.totalpaymentReference | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>
              </div>

              <!-- Insurance Receipt Info (SEGUROS_MERCANTIL / SEGUROS_CARACAS) -->
              <div *ngIf="item?.installMent?.params?.typeProduct === 'SEGUROS_MERCANTIL' || item?.installMent?.params?.typeProduct === 'SEGUROS_CARACAS'"
                   class="mt-4 p-2 bg-blue-50 border border-blue-100 rounded-lg">
                <p class="text-xs font-semibold text-blue-700 uppercase tracking-wide mb-1">Información del Recibo</p>
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <p class="text-xs font-medium text-gray-500">N° Recibo</p>
                    <p class="text-xs text-gray-900">
                      {{ item?.installMent?.params?.insurance?.receipt_number || 'Sin recibo generado' }}
                    </p>
                  </div>
                  <div>
                    <p class="text-xs font-medium text-gray-500">Estado del Recibo en la Aseguradora</p>
                    <p class="text-xs text-gray-900">
                      {{ item?.installMent?.params?.insurance?.receipt_status || '-' }}
                    </p>
                  </div>
                </div>

                <!-- Reportar la cuota a Mercantil desde aquí mismo: la misma acción
                     de la pestaña "Reporte de Cuotas a Seguros", en el sitio donde el
                     analista ya está mirando el caso. El botón no envía: abre el
                     ensayo con el payload exacto, y el envío exige confirmación.
                     Seguros Caracas queda fuera: no tiene summary contra el que
                     verificar, así que no hay reporte por cuota. -->
                <div data-rbac-permiso="seguros.reporte_pagos.read config.seguros.read" *ngIf="esCuotaSegurosMercantil(item) && _auth.hasAnyPermission(['seguros.reporte_pagos.read', 'config.seguros.read'])"
                     class="mt-2 pt-2 border-t border-blue-100 flex items-center justify-between flex-wrap gap-2">
                  <div class="text-xs">
                    <span class="px-2 py-0.5 rounded font-medium" [ngClass]="chipSM(item).clase">{{ chipSM(item).label }}</span>
                    <!-- Ausente NO es "SM dice que no está pagada": es que nunca se
                         lo preguntamos. La ficha tiene que distinguirlo. -->
                    <span *ngIf="verificadaEnSM(item)" class="text-gray-500 ml-2">
                      Verificado con SM el {{ verificadaEnSM(item) | date:'dd/MM/yyyy HH:mm' }}
                    </span>
                    <span *ngIf="!verificadaEnSM(item)" class="text-amber-700 ml-2">
                      Nunca se le preguntó a SM: este dato es del último corte del sync
                    </span>
                    <span *ngIf="item?.installMent?.params?.sm_report?.attempts" class="text-gray-500 ml-2">
                      · {{ item?.installMent?.params?.sm_report?.attempts }} intento(s)
                    </span>
                    <!-- Quién la reportó y por qué vía: el cobro la reporta solo,
                         y no es lo mismo que la haya enviado una persona. -->
                    <span *ngIf="item?.installMent?.params?.sm_report?.sent_at" class="text-gray-500 ml-2">
                      · {{ quienReportoSM(item) }}
                    </span>
                  </div>

                  <app-insurance-installment-report
                    [installmentCode]="item?.installMent?.code"
                    [policyCode]="item?.installMent?.params?.insurance?.policy_code"
                    [orden]="item?.installMent?.order"
                    [recibo]="item?.installMent?.params?.insurance?.receipt_number"
                    [polizaNumero]="item?.installMent?.params?.insurance?.policy_number"
                    [credito]="invoiceSelected?.identifier"
                    [puedeReportar]="cuotaReportableSM(item)"
                    [compacto]="true"
                    (reportado)="onCuotaReportadaSM()">
                  </app-insurance-installment-report>
                </div>

                <p *ngIf="item?.installMent?.params?.typeProduct === 'SEGUROS_CARACAS'" class="text-xs text-gray-500 mt-2">
                  Seguros Caracas no tiene consulta de estado contra la aseguradora: esta cuota no se reporta por aquí.
                </p>
              </div>

              <!-- External Payment Alert.
                   Se muestra por el DATO de la detección, no por `is_paid`: desde que
                   la cuota se puede reportar a SM desde la consola, `is_paid: true` es
                   el desenlace normal de un cobro nuestro y no significa que el cliente
                   haya pagado por fuera. Sin ese dato el aviso salía vacío ("Detectado:"
                   y nada más) en toda cuota que la aseguradora reconociera. -->
              <div *ngIf="tieneAvisoPagoExterno(item)" class="mt-2 p-4 bg-orange-50 border-l-4 border-orange-400 rounded-r">
                <div class="flex items-start">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-orange-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3 flex-1">
                    <p class="text-sm font-medium text-orange-800">
                      {{ etiquetaPagoExterno(item) }}
                    </p>
                    <p *ngIf="item?.installMent?.params?.external_payment_detected_at"
                       class="mt-1 text-xs text-orange-700">
                      Detectado: {{formatExternalPaymentDate(item?.installMent?.params?.external_payment_detected_at)}}
                    </p>
                    <p *ngIf="item?.installMent?.params?.insurance?.external_payment_info?.cdIngreso"
                       class="mt-1 text-xs text-orange-700">
                      Ingreso: {{item?.installMent?.params?.insurance?.external_payment_info?.cdIngreso}}
                    </p>
                  </div>
                </div>
              </div>

              <!-- View Payments Button -->


              <!-- Payments List -->
              <div *ngIf="item?.payments?.length > 0 || item?.paymentReference?.length > 0" class="mt-6 border-t border-gray-200 pt-6">
                <div class="flex items-center justify-between mb-4">
                  <h4 class="text-sm font-semibold text-gray-900">Pagos</h4>
                  <button *ngIf="item?.installMent?.payment_status?.code == 'PaymentComplete'"
                          (click)="getPersonInstallmentpayment(item?.installMent)"
                          class="text-sm text-blue-600 hover:text-blue-800 font-medium">
                    Ver pagos
                  </button>
                </div>

                <div class="space-y-3">
                  <!-- Confirmed Payments -->
                  <div *ngFor="let item2 of item?.payments" class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div class="flex-1">
                      <p class="text-sm font-medium text-gray-900">{{item2?.payment?.paymentMethodId}}</p>
                      <button (click)="openBottom(paymentcontainer,{ person_code: item?.installMent?.invoice?.customer?.code, code_payment: item2?.payment?.code})"
                              class="text-xs text-blue-600 hover:text-blue-800">
                        {{item2?.payment?.code}}
                      </button>
                    </div>
                    <div class="text-right">
                      <p class="text-sm font-semibold text-gray-900">
                        {{item2?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                      <span *ngIf="item2?.payment?.reconciled_payment" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Aprobado
                      </span>
                      <span *ngIf="!item2?.payment?.reconciled_payment" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 cursor-pointer">
                        Por conciliar
                      </span>
                    </div>
                  </div>

                  <!-- Payment References -->
                  <div *ngFor="let item2 of item?.paymentReference" class="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div class="flex-1">
                      <p class="text-sm font-medium text-gray-900">{{item2?.payment?.paymentMethodId}}</p>
                      <p class="text-xs text-gray-500">{{item2?.payment?.code}}</p>
                    </div>
                    <div class="text-right">
                      <p class="text-sm font-semibold text-gray-900">
                        {{item2?.payment?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                      <span *ngIf="item2?.payment?.reconciled_payment" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        Conciliado
                      </span>
                      <span *ngIf="!item2?.payment?.reconciled_payment" class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 cursor-pointer">
                        Por conciliar
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Missing Amount Alert -->
              <div *ngIf="!item?.installMent?.payment_status_remante_base && !item?.installMent?.payment_status_remante_next">
                <div *ngIf="item?.installMent?.total_dueBalance > 0 && invoiceSelected?.payment_status?.code != 'PaymentTrash'"
                     class="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <div class="flex items-center">
                    <i class="fas fa-exclamation-triangle text-yellow-600 mr-2"></i>
                    <span class="text-sm font-medium text-yellow-800">
                      {{item?.installMent?.total_dueBalance | currency:'USD':'': '1.2-2'}} USD faltantes
                    </span>
                  </div>
                </div>
              </div>

              <div *ngIf="item?.installMent?.payment_status_remante_next">
                <div *ngIf="item?.installMent?.total_dueBalance_next > 0 && invoiceSelected?.payment_status?.code != 'PaymentTrash'"
                     class="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <div class="flex items-center">
                    <i class="fas fa-exclamation-triangle text-yellow-600 mr-2"></i>
                    <span class="text-sm font-medium text-yellow-800">
                      {{item?.installMent?.total_dueBalance_next | currency:'USD':'': '1.2-2'}} USD faltantes
                    </span>
                  </div>
                </div>
              </div>

              <!-- Fees Section -->
              <div *ngIf="item?.fees?.length > 0" class="mt-6 border-t border-gray-200 pt-6">
                <h4 class="text-sm font-semibold text-gray-900 mb-4">Penalidades</h4>
                <div class="space-y-3">
                  <div *ngFor="let fee of item.fees"
                       class="p-4 rounded-lg border-2"
                       [ngClass]="{
                         'border-green-200 bg-green-50': fee?._visualStatus === 'complete' || fee?._visualStatus === 'awaiting-close',
                         'border-gray-200 bg-gray-50': fee?._visualStatus === 'inactive',
                         'border-yellow-200 bg-yellow-50': fee?._visualStatus === 'pending'
                       }">
                    <!-- Encabezado: monto + badge -->
                    <div class="flex items-start justify-between mb-3">
                      <div>
                        <p class="text-lg font-semibold text-gray-900">{{fee.amount | currency:'USD':'': '1.2-2'}} USD</p>
                        <p class="text-xs text-gray-500 mt-0.5">
                          {{ fee?.fee?.concept_deduction?.name || 'Penalización por pago con retraso' }}
                          <span *ngIf="fee?.fee?.code" class="text-gray-400"> · {{ fee?.fee?.code }}</span>
                        </p>
                      </div>
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap"
                            [ngClass]="{
                              'bg-green-100 text-green-800': fee?._visualStatus === 'complete' || fee?._visualStatus === 'awaiting-close',
                              'bg-gray-100 text-gray-700': fee?._visualStatus === 'inactive',
                              'bg-yellow-100 text-yellow-800': fee?._visualStatus === 'pending'
                            }">
                        <ng-container [ngSwitch]="fee?._visualStatus">
                          <ng-container *ngSwitchCase="'complete'">Pago Completado</ng-container>
                          <ng-container *ngSwitchCase="'awaiting-close'">
                            Completo · Esperando cierre
                            <span class="inline-block w-1.5 h-1.5 rounded-full bg-amber-400 ml-1.5"></span>
                          </ng-container>
                          <ng-container *ngSwitchCase="'inactive'">{{fee?.payment_status?.name || 'Anulado'}}</ng-container>
                          <ng-container *ngSwitchDefault>Pago Pendiente</ng-container>
                        </ng-container>
                      </span>
                    </div>

                    <!-- Info compacta -->
                    <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
                      <div *ngIf="fee?.days !== undefined && fee?.days !== null">
                        <span class="text-gray-500">Días Mora: </span>
                        <span class="font-medium" [ngClass]="{ 'text-amber-600': fee?.days > 0, 'text-gray-900': fee?.days <= 0 }">{{ fee?.days }}</span>
                      </div>
                      <div *ngIf="fee?.date" class="text-right">
                        <span class="text-gray-500">Creado: </span>
                        <span class="font-medium text-gray-900">{{ fee?.date | date: 'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                      <div *ngIf="fee?.due_balance > 0 && fee?._visualStatus !== 'inactive'">
                        <span class="text-gray-500">Saldo: </span>
                        <span class="font-semibold text-amber-700">{{ fee?.due_balance | currency:'USD':'$': '1.2-2' }}</span>
                      </div>
                      <div *ngIf="fee?.closed_at && fee?._visualStatus === 'complete'" class="col-span-2">
                        <span class="text-gray-500">Cerrado: </span>
                        <span class="font-medium text-gray-900">{{ fee?.closed_at | date: 'dd/MM/yyyy HH:mm' }}</span>
                      </div>
                    </div>

                    <!-- Banner explicativo: esperando cierre -->
                    <div *ngIf="fee?._visualStatus === 'awaiting-close'"
                         class="mt-3 p-2 bg-emerald-50 border-l-4 border-emerald-500 rounded text-xs text-emerald-900">
                      <i class="fas fa-check-circle mr-1"></i>
                      Pago completo. Se marcará como Completado al cerrar la cuota.
                    </div>

                    <!-- Pagos Aplicados -->
                    <div *ngIf="(fee?.paymentsClean?.length > 0) || (fee?.paymentsFeeReferencesClean?.length > 0 && fee?._visualStatus !== 'complete')"
                         class="mt-3 pt-3 border-t border-gray-200">
                      <p class="text-xs font-semibold text-gray-600 mb-2">Pagos Aplicados</p>
                      <div class="space-y-1.5">
                        <div *ngFor="let p of fee?.paymentsClean"
                             class="flex items-center justify-between text-xs">
                          <div class="min-w-0">
                            <div class="font-medium text-gray-900 truncate">{{ p?.payment?.paymentMethodId || p?.payment?.payment?.name || 'Pago' }}</div>
                            <button type="button"
                                    (click)="openBottom(paymentcontainer, { person_code: item?.installMent?.invoice?.customer?.code, code_payment: p?.payment?.code })"
                                    class="text-blue-600 hover:text-blue-800 hover:underline truncate text-left">
                              {{ p?.payment?.code }}
                            </button>
                          </div>
                          <div class="text-right ml-2 whitespace-nowrap">
                            <div class="font-semibold text-gray-900">{{ p?.amount | currency:'USD':'$': '1.2-2' }}</div>
                            <span class="inline-block px-1.5 py-0.5 rounded text-[10px] font-medium"
                                  [ngClass]="{ 'bg-green-100 text-green-800': p?.payment?.reconciled_payment, 'bg-amber-100 text-amber-800': !p?.payment?.reconciled_payment }">
                              {{ p?.payment?.reconciled_payment ? 'Aprobado' : 'Por conciliar' }}
                            </span>
                          </div>
                        </div>
                        <ng-container *ngIf="fee?._visualStatus === 'pending' || fee?._visualStatus === 'awaiting-close'">
                          <div *ngFor="let p of fee?.paymentsFeeReferencesClean"
                               class="flex items-center justify-between text-xs">
                            <div class="min-w-0">
                              <div class="font-medium text-gray-900 truncate">{{ p?.payment?.paymentMethodId || p?.payment?.payment?.name || 'Pago' }}</div>
                              <button type="button"
                                      (click)="openBottom(paymentcontainer, { person_code: item?.installMent?.invoice?.customer?.code, code_payment: p?.payment?.code })"
                                      class="text-blue-600 hover:text-blue-800 hover:underline truncate text-left">
                                {{ p?.payment?.code }}
                              </button>
                            </div>
                            <div class="text-right ml-2 whitespace-nowrap">
                              <div class="font-semibold text-gray-900">{{ p?.payment?.amount | currency:'USD':'$': '1.2-2' }}</div>
                              <span class="inline-block px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-800">
                                Por conciliar
                              </span>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <!-- Auditoría de anulación -->
                    <div *ngIf="fee?._visualStatus === 'inactive'"
                         class="mt-3 pt-3 border-t border-gray-200 text-xs space-y-0.5">
                      <ng-container *ngIf="fee?.exonerated_by_user || fee?.exonerated_at; else autoOrManualFee">
                        <p *ngIf="fee?.exonerated_by_user" class="text-gray-700">
                          <span class="font-medium">Anulado por:</span>
                          {{ fee?.exonerated_by_user?.name }} {{ fee?.exonerated_by_user?.lastName }}
                          <span *ngIf="fee?.exonerated_by_user?.email" class="text-gray-500"> · {{ fee?.exonerated_by_user?.email }}</span>
                        </p>
                        <p *ngIf="fee?.exonerated_at" class="text-gray-700">
                          <span class="font-medium">Fecha:</span>
                          {{ fee?.exonerated_at | date: 'dd/MM/yyyy HH:mm' }}
                        </p>
                        <p class="text-gray-700">
                          <span class="font-medium">Motivo:</span>
                          {{ fee?.exonerated_reason || 'Anulación manual' }}
                        </p>
                      </ng-container>
                      <ng-template #autoOrManualFee>
                        <p class="text-gray-700">
                          <span class="font-medium">Motivo:</span>
                          {{ fee?.message || 'Anulación manual' }}
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Details View -->
      <div *ngIf="view == 3" class="max-w-4xl mx-auto">

        <!-- Payment Header -->
        <div *ngIf="installments" class="bg-white rounded-lg shadow-sm p-4 mb-4 text-center">
          <div class="border-b border-gray-200 pb-3 mb-3">
            <h2 class="text-xl font-bold text-gray-900 mb-2">Detalle de Pago</h2>
          </div>

          <div class="text-center">
            <p class="text-sm font-medium text-gray-500">ID Transacción</p>
            <p class="text-lg font-semibold text-blue-600 mb-3">{{invoiceSelected?.identifier}}</p>

            <h3 class="text-lg font-bold text-gray-900">
              Pago {{ installMentSelected?.order < 1 ? 'Inicial' : 'Cuota ' + installMentSelected?.order }}
            </h3>
          </div>
        </div>

        <!-- Payment Details -->
        <div class="space-y-4">
          <div *ngFor="let payment of payment_base" class="bg-white rounded-lg shadow-sm">

            <!-- Payment Header -->
            <div class="p-3 border-b border-gray-200">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-semibold text-gray-900">Pago</h3>
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [ngClass]="{
                        'bg-green-100 text-green-800': payment?.payment?.typeTransaction == 'AUTO',
                        'bg-gray-100 text-gray-800': payment?.payment?.typeTransaction != 'AUTO'
                      }">
                  {{payment?.payment?.typeTransaction == 'AUTO' ? 'Auto' : 'Manual'}}
                </span>
              </div>
            </div>

            <!-- Payment Info -->
            <div class="p-4">
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

                <!-- Code -->
                <div class="space-y-1 md:col-span-2 lg:col-span-3">
                  <p class="text-sm font-medium text-gray-500">Código</p>
                  <p class="text-sm text-gray-900 font-mono">{{payment?.payment?.code}}</p>
                </div>

                <!-- Conciliation -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Conciliación</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="{
                          'bg-green-100 text-green-800': payment?.payment?.typeTransaction == 'AUTO',
                          'bg-gray-100 text-gray-800': payment?.payment?.typeTransaction != 'AUTO'
                        }">
                    {{payment?.payment?.typeTransaction == 'AUTO' ? 'Auto' : 'Manual'}}
                  </span>
                </div>

                <!-- Amount -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Monto total</p>
                  <p class="text-lg font-semibold text-gray-900">
                    {{payment?.payment?.amount | currency:'USD':'': '1.2-2'}} USD
                  </p>
                </div>

                <!-- Status -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Estatus</p>
                  <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Pago conciliado
                  </span>
                </div>

                <!-- Date -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Fecha</p>
                  <p class="text-sm text-gray-900">{{payment?.payment?.register_payment_date | date: 'dd/MM/yyyy h:mm:ss a'}}</p>
                </div>

                <!-- Payment Method -->
                <div class="space-y-1">
                  <p class="text-sm font-medium text-gray-500">Forma de Pago</p>
                  <p class="text-sm text-gray-900" [title]="payment?.payment?.payment_method?.description">
                    {{payment?.payment?.payment_method?.name}}
                  </p>
                </div>

                <!-- Confirmation Number -->
                <div class="space-y-1 md:col-span-2 lg:col-span-3">
                  <p class="text-sm font-medium text-gray-500">Número de confirmación</p>
                  <p class="text-sm text-gray-900 font-mono">{{payment?.payment?.paymentMethodId}}</p>
                </div>
              </div>

              <!-- Voucher Section -->
              <div *ngIf="payment?.payment?.responseAutoConfirm?.voucher" class="mt-4 border-t border-gray-200 pt-4">
                <h4 class="text-sm font-semibold text-gray-900 mb-3">Voucher</h4>

                <div *ngIf="payment?.payment?.responseAutoConfirm?.descripcion" class="mb-3">
                  <p class="text-sm font-medium text-gray-900">{{payment?.payment?.responseAutoConfirm?.descripcion}}</p>
                </div>

                <div class="bg-gray-50 rounded-lg p-1 max-w-xs overflow-hidden">
                  <div class="text-base text-gray-900 font-normal whitespace-pre-wrap uppercase tracking-wide"
                       [innerHTML]="payment?.payment?.responseAutoConfirm?.voucher"
                       style="font-size: 14px; line-height: 1.2; font-family: Arial, sans-serif;">
                  </div>
                </div>
              </div>

              <!-- Distribution Section -->
              <div *ngIf="payment?.installMentsPayment?.length > 0" class="mt-4 border-t border-gray-200 pt-4">
                <h4 class="text-sm font-semibold text-gray-900 mb-3">Distribución</h4>

                <div class="space-y-2">
                  <div *ngFor="let item of payment?.installMentsPayment" class="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                    <div>
                      <p class="text-sm font-medium text-blue-600">
                        {{ item?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item?.installMent?.order }}
                      </p>
                      <p class="text-xs text-gray-500 font-mono">{{item?.installMent?.code}}</p>
                    </div>
                    <div>
                      <p class="text-sm font-semibold text-gray-900">
                        {{item?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- IGTF Section -->
              <div *ngIf="payment?.paymen_categ_concept_deduc?.length > 0" class="mt-4 border-t border-gray-200 pt-4">
                <h4 class="text-sm font-semibold text-gray-900 mb-3">Deducciones</h4>
                <div class="space-y-2">
                  <div *ngFor="let item of payment?.paymen_categ_concept_deduc" class="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                    <div *ngIf="item?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                      <p class="text-sm font-medium text-blue-600">
                        {{item?.category_concept_deduction?.concept_deduction?.name}}
                        <span class="text-gray-500" *ngIf="item?.category_concept_deduction.isPorcent">
                          {{item?.category_concept_deduction?.amount}}%
                        </span>
                      </p>
                    </div>
                    <div *ngIf="item?.category_concept_deduction?.concept_deduction?.name == 'IGTF'">
                      <p class="text-sm font-semibold text-gray-900">
                        {{item?.amount | currency:'USD':'': '1.2-2'}} USD
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Payment Detail Modal -->
<ng-template #paymentcontainer let-offcanvas>
  <div class="offcanvas-header">
      <div class="container ">
          <div class="row">
              <div class="col-12 col-md-10 offset-md-1 ">
                  <div class="row">
                      <div class="col-10">
                          <div class="text-capitalize h5 text-secondary mt-2 ">
                             Detalle de Pago
                          </div>
                      </div>
                      <div class="col-2 text-end pt-2">
                          <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click'); "></button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="offcanvas-body">
      <div class=" container">
          <div class="row">
              <div class=" col-12 col-md-10 offset-md-1">
                  <div class="text-start">
                      <app-person-payments [code_person]="params_payment['person_code']" [code_payment]="params_payment['code_payment']" (resetStatus)="response($event)"></app-person-payments>

                  </div>
              </div>
          </div>
      </div>
  </div>
</ng-template>

<!-- EST-01/06: panel lateral con la traza de la compra (sin salir de Compras financiadas) -->
<div *ngIf="liqPanel" class="fixed inset-0 z-50 flex justify-end bg-black/30" (click)="cerrarTrazaLiq()">
  <aside class="h-full w-full max-w-[460px] overflow-y-auto bg-white p-5 shadow-xl" (click)="$event.stopPropagation()">
    <div class="mb-3 flex items-start justify-between gap-3">
      <div>
        <p class="m-0 text-xs text-gray-500">Liquidación al comercio</p>
        <h3 class="m-0 text-base font-semibold">Compra {{ liqPanel.venta }}<span *ngIf="liqPanel.comercio"> · {{ liqPanel.comercio }}</span></h3>
      </div>
      <button type="button" class="text-gray-600" (click)="cerrarTrazaLiq()" aria-label="Cerrar">✕</button>
    </div>
    <div *ngIf="liqPanelCargando" class="h-24 w-full animate-pulse rounded bg-gray-100"></div>
    <div *ngIf="liqPanelError" class="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">{{ liqPanelError }}</div>
    <ng-container *ngIf="!liqPanelCargando && !liqPanelError && liqPanel.estado">
      <span [ngClass]="claseMarca(liqPanel.estado)">{{ liqPanel.texto }}</span>
      <h4 class="mt-5 mb-2 text-sm font-semibold" *ngIf="liqPanel.traza?.length">Traza</h4>
      <ol class="relative my-0 ml-2 list-none space-y-4 border-l-2 border-gray-200 py-0 pr-0 pl-5" *ngIf="liqPanel.traza?.length">
        <li class="relative" *ngFor="let t of liqPanel.traza">
          <span class="absolute -left-[27px] top-1 h-3 w-3 rounded-full bg-gray-900 ring-4 ring-white"></span>
          <p class="m-0 text-sm"><span class="text-xs text-gray-500">{{ fechaLiq(t.fecha) }}</span>&nbsp; <b>{{ t.titulo }}</b></p>
          <p class="m-0 text-xs text-gray-500" *ngIf="t.detalle">{{ t.detalle }}</p>
          <p class="m-0 text-xs text-gray-500" *ngIf="t.quien">{{ t.quien }}</p>
        </li>
      </ol>
      <ul class="m-0 mt-4 list-none space-y-1 p-0" *ngIf="liqPanel.modelo === 'COBRANZA'">
        <li *ngFor="let c of liqPanel.cuotas" class="flex items-center justify-between text-sm"><span>Cuota {{ c.numero }}</span><span [ngClass]="claseMarca(c.estado)">{{ c.texto }}</span></li>
      </ul>
      <a class="mt-4 inline-block text-sm underline" [routerLink]="['/console/liquidacion/consultas']" [queryParams]="{ vista: 'buscar', venta: liqPanel.venta }">Abrir en Consultas →</a>
    </ng-container>
  </aside>
</div>
